angular.module('admin.articles', [
  'admin.articles.index',
  'admin.articles.detail'
]);


// WEBPACK FOOTER //
// ./client/src/app/admin/articles/index.js